<template>
    <c-modal
            confirmLabel="Save User"
            cancelLabel="Cancel"
            centered size="md"
            title="Add User"
            :tag="tag"
            :icon="icon"
            :iconClass="iconClass"
            :label="label"
            :tagAttrs="tagAttrs"
            :progressing="loading"
            @submit="submit"
            @show="show"
            @hide="hide"
            ref="createOrder"
            no-close-on-esc
            no-close-on-backdrop
    >
        <template>
            <b-alert :show="errors.any()" variant="danger" class="px-4">
                <ul class="m-0 px-1">
                    <li v-for="err in errors.all()" :key="err">{{err}}</li>
                </ul>
            </b-alert>
            <div>
                <b-form-group>
                    <b-input-group :prepend="'First Name'">
                        <b-input
                                class="myFeild"
                                :name="'First Name'"
                                v-validate="'required'"
                                placeholder="Required"
                                v-model="model.FirstName"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group>
                    <b-input-group :prepend="'Last Name'">
                        <b-input
                                class="myFeild"
                                :name="'Last Name'"
                                v-validate="'required'"
                                placeholder="Required"
                                v-model="model.LastName"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group>
                    <b-input-group :prepend="'Cell Phone '"><b-input-group-append>
                    <b-input-group-text class="bg-white"            :class="'border-left-0'">
                        +1
                        </b-input-group-text>
                        </b-input-group-append>
                        <b-input
                                class="myFeild"
                                :name="'Cell Phone Number'"
                                v-mask="'###-###-####'"
                                placeholder="Optional"
                                v-model="model.Phone"/>
                    </b-input-group>
                </b-form-group>

                <b-form-group>
                    <b-input-group :prepend="'Email'">
                        <b-input
                                class="myFeild"
                                :name="'Email'"
                                v-validate="'required|email'"
                                placeholder="Required"
                                v-model="model.Email"/>
                    </b-input-group>
                    <p v-if="existEmail" class="text-danger mb-0 mt-3 font-weight-bold">
                        Email already registered.Please enter another Email address.
                    </p>
                </b-form-group>

                <b-form-group class="mb-0">
                    <b-input-group :prepend="'Role'">
                        <b-form-select
                            :name="'Role'"
                            v-validate="'required'"
                            :options="roles"
                            value-field="ClientTypeID"
                            text-field="ClientType"
                            v-model="model.ClientTypeID"/>
                    </b-input-group>
                </b-form-group>
            </div>
        </template>
    </c-modal>
</template>

<script>
    import CModal from "@/components/shared/Cmodal";
    export default {
        name: "attentionRemoveItems",
        components: {CModal},
        props: {
            tag: {type: [String, null]},
            icon: {type: String},
            iconClass: {type: String},
            label: {type: String, required: true}
        },
        data () {
            return {
                loading: false,
                tagAttrs: {
                    variant: 'danger',
                    size: 'sm'
                },
                roles: [],
                existEmail: false,
                model: {
                    FirstName: '',
                    LastName: '',
                    Phone: '',
                    Email: '',
                    ClientTypeID: '',
                }
            }
        },
        methods: {
            show () {
                this.getRoles()
            },
            getRoles () {
                const filter = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId
                }
                return this.$api.getRestaurant.GetDashboardClientRole(filter, true).then(res => {
                    this.progressing = false
                    if (res.success) {
                        this.roles = res.roles
                        if (this.roles.length) {
                            this.model.ClientTypeID = this.roles[0].ClientTypeID
                        }
                        return res.roles
                    }
                }).catch(() => {

                })
            },
            checkEmail () {
                const model = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    Email: this.model.Email
                }
                this.loading = true
                this.existEmail = false
                return this.$api.getRestaurant.CheckClientEmail(model).then(res => {
                    if (res.success) {
                        const model = {...this.model}
                        model.UserID = localStorage.getItem('userID')
                        model.RestaurantID = this.$store.state.selectedRestaurantId
                        model.TableIKey = 0
                        model.Phone = model.Phone.replace(/-/g, '')
                        if(model.Phone != "")
                        model.Phone = '+1'+model.Phone
                        
                        
                        this.loading = true
                        return this.$api.getRestaurant.InsertRestaurantUser(model).then(res => {
                            this.loading = false
                            if (res.success) {
                                this.$emit('refresh')
                                if (this.$refs.createOrder) {
                                    this.$refs.createOrder.hide()
                                    this.reset()
                                }
                            } else {
                                this.$showError(res.message)
                            }
                        })
                    } else {
                        if (res.message === 'User already exists.') {
                            this.existEmail = true
                            this.loading = false
                        } else {
                            this.existEmail = false
                            this.loading = false
                            this.$showError(res.message)
                        }
                    }
                }).catch(() => {

                })
            },
            submit () {
                this.$validator.validateAll().then(proceed => {
                    if (proceed) {
                        this.checkEmail()

                    }
                })
            },
            reset () {
                this.$validator.pause()
                this.model = {
                    FirstName: '',
                    LastName: '',
                    Phone: '',
                    Email: '',
                    ClientTypeID: ''
                }
                return this.$validator.reset().then(() => {
                    this.$validator.resume()
                })
            },
            hide() {
                this.reset()
            }
        }
    }
</script>

<style scoped>

</style>
